export const FAQ_BUTTON_ID = 'faq-button';